import {
  replace,
  split,
  compact,
} from 'lodash';
import axios from 'axios';
import { authService } from '../utils/auth-service';


const getInfluencerDetails = ({ email }, { contentTags, brandTags, description }) => {
  const cTags = contentTags ? replace(contentTags, /\s+/g, '') : '';
  const bTags = brandTags ? replace(brandTags, /\s+/g, '') : '';

  const contentTagsArray = cTags.length ? split(cTags, ',') : [];
  const brandTagsArray = bTags.length ? split(bTags, ',') : [];

  const details = {
    type: 'influencerDetails',
    attributes: {
      email,
      associated: false,
      contentTags: compact(contentTagsArray),
      brandTags: compact(brandTagsArray),
      description: description || '',
    },
  };

  return details;
};

const createInfluencerDetails = (influencer, user, restClient) => {
  const details = getInfluencerDetails(influencer, user);


  console.log(details);

  return restClient.post('influencerDetails', {
    data: details,
  });
};

export default ({ id, email, contentTags, brandTags, description }, organisationId) => {
  const aggregate = {};
  const restClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 5000,
    headers: {
      Authorization: `Bearer ${authService.getToken()}`,
    },
  });
  aggregate.influencerId = id;
  createInfluencerDetails({ email }, { contentTags, brandTags, description }, restClient)
    .then(r => {
      if (aggregate.influencerId && r.data.data.id) {
        restClient.post('influencerLink', {
          data: {
            type: 'influencerLink',
            attributes: {
              organisation: {
                type: 'organisations',
                id: organisationId,
              },
              influencer: {
                type: 'influencer',
                id: aggregate.influencerId,
              },
              influencerDetails: {
                type: 'influencerDetails',
                id: r.data.data.id,
              },
            },
          },
        })
          .then(r2 => {
            console.log(`influencer ${id} and link ${r2.data.data.id} created!`);
          });
      } else {
        console.log(`error creating influencer >>> ${id}`);
      }
    })
    .catch(e => {
      console.log(e);
      throw (e);
    });
};



/** WEBPACK FOOTER **
 ** ./src/utils/add-influencer-to-organisation.js
 **/